import { isSameDay } from 'date-fns';

export const isBeforeMinTime = (date: Date | null, minTime: Date): boolean => {
  // if selected date is same as minimum date but hours are before
  return date instanceof Date && isSameDay(date, minTime) && date < minTime;
};
